export const routes = [
  {
    path: "/analise-evidencias-ia",
    component: () =>
      import(
        /* webpackChunkName: "analise-evidencias-ia" */ "./components/Layout.vue"
      ),
    children: [
      {
        path: "",
        redirect: "/analise-evidencias-ia/painel",
      },
      {
        path: "painel",
        name: "analise-evidencias-ia.painel",
        component: () =>
          import(
            /* webpackChunkName: "analise-evidencias-ia" */ "./components/Painel.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "validacao",
        name: "analise-evidencias-ia.validacao",
        component: () =>
          import(
            /* webpackChunkName: "analise-evidencias-ia" */ "./components/Painel.vue"
          ),
        props: {
          validacao: true,
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "regras",
        name: "analise-evidencias-ia.regras",
        component: () =>
          import(
            /* webpackChunkName: "analise-evidencias-ia" */ "./components/Regras.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
